import './bootstrap';
import '../vendor/adminlte/js/adminlte.js';

import "jquery-ui/dist/jquery-ui.js";

import autoComplete from '@tarekraafat/autocomplete.js';
import { autocomplete_params } from './utils';
import Stats from './stats';

import { loadScript } from "@paypal/paypal-js";

import.meta.glob([
    '../img/**',
]);

function messageModal(message, type) {
    var m = $('#messageModal').clone();
    m.removeClass('modal-placeholder').addClass('modal-' + type);
    m.find('.message').text(message);
    m.modal('show');
}

function commonInit(container) {
    $('[data-bs-toggle="tooltip"]', container).tooltip();

    let topology = $('.topology_select', container);

    if (topology.length > 0) {
        new autoComplete({
            selector: () => topology.get(0),
            data: {
                src: [
                    {
                        text: 'Via',
                        prefix: 'Via',
                    },
                    {
                        text: 'Viale',
                        prefix: 'Viale',
                    },
                    {
                        text: 'Corso',
                        prefix: 'Corso',
                    },
                    {
                        text: 'Piazza',
                        prefix: 'Piazza',
                    },
                ],
                keys: ['text'],
            },
            ...autocomplete_params(),
        });

        topology.on('selection', (e) => {
            $(e.currentTarget).val(e.originalEvent.detail.selection.value.text);
        });
    }

    var carousels = container.find('.carousel');
    carousels.each((index, node) => {
        new bootstrap.Carousel(node);
    });

    Stats.init(container);
}

function startPaypal()
{
    let subscription_buttons = $('.paypal-subscription-button');
    let pay_button = $('#paypal-pay-button');

    if (subscription_buttons.length > 0 || pay_button.length > 0) {
        let paypal_id = $('meta[name=paypal]').attr('content');

        loadScript({
            'client-id': paypal_id,
            'currency': 'EUR',
            'locale': 'it_IT',
            'vault': true,
        }).then((paypal) => {
            subscription_buttons.each(function() {
                var this_id = 'paypal-button-' + Math.ceil(Math.random() * 1000);
                $(this).attr('id', this_id);
                var form = $(this).closest('form');

                paypal.Buttons({
                    createSubscription: function(data, actions) {
                        return actions.subscription.create({
                            'plan_id': $('input[name="paypal_plain_id"]', form).val(),
                        });
                    },
                    onApprove: function(data, actions) {
                        $('input[name=paypalToken]', form).val(data.subscriptionID);
                        form.submit();
                    }
                }).render('#' + this_id);
            });

            if (pay_button.length > 0) {
                paypal.Buttons({
                    createOrder: function(data, actions)  {
                        return actions.order.create({
                            purchase_units: [{
                                amount:  {
                                    value: $('#rechargeAmountForm').val(),
                                }
                            }]
                        });
                    },
                    onApprove: function(data, actions) {
                        var amount = $('#rechargeAmountForm').val();
                        $('form.paypal-custom-form input[name=amount]').val(amount);
                        $('form.paypal-custom-form input[name=paypalToken]').val(data.orderID);
                        $('form.paypal-custom-form').submit();
                    }
                }).render('#paypal-pay-button');
            }
        });
    }
}

function formatNumber(number, wrapper) {
    var prefix = number.substring(0, 5);
    $(wrapper).find('option').each(function() {
        var currentprefix = $(this).val();
        if (prefix.indexOf(currentprefix) == 0) {
            $(this).prop('selected', true);
            var numberNoPrefix = number.substring(currentprefix.length);
            $(wrapper).find('#recipientFaxNumber').val(numberNoPrefix);
            $(this).parent().trigger("change");
        }
    })
}

function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

function checkAnySelected() {
    if ($(".multipleFaxAction input:checked").length > 0) {
        $('.btn.faxaction').prop("disabled", false);
    }
    else {
        $('.btn.faxaction').prop("disabled", true);
    }
}

function multipleFileCell(file) {
    let input = $('#activeFileUpload');
    let fileName = file.name;
    let fileSize = file.size;
    let fileType = file.type;
    let valid = true;
    let iconclass = '';

    if (fileSize > $('[name=maxfilesize]').val()) {
        messageModal('Il file caricato è troppo grande!', 'danger');
        input.val(null);
        return;
    }

    switch (fileType) {
        case 'text/plain':
            iconclass = "fa-file-text";
            break;
        case 'application/pdf':
            iconclass = "fa-file-pdf";
            break;
        case 'application/vnd.oasis.opendocument.text':
            iconclass = "fa-file-word";
            break;
        case 'application/vnd.oasis.opendocument.spreadsheet':
            iconclass = "fa-file-excel";
            break;
        case 'image/jpeg':
        case 'image/png':
            iconclass = "fa-file-image";
            break;
        default:
            var extension = fileName.substr((fileName.lastIndexOf('.') + 1)).toLowerCase();
            console.log('upload extension: '+extension);
			switch (extension) {
                case 'xls':
                case 'xlsx':
                    iconclass = "fa-file-excel";
                    break;
                case 'doc':
                case 'docx':
                case 'rtf':
                    iconclass = "fa-file-word";
                    break;
                default:
                    iconclass = "fa-file";
                    valid = false;
                    break;
            }
    }

    if (valid == false || iconclass == '') {
        messageModal('Il tipo di file che hai caricato non è supportato.', 'danger');
        input.val(null);
        return;
    }

    var currentfile = input.parents('.singolefile');
    var fileswrapper = input.parents('.multiplefiles');
    var filemodel = $('#uploadmodel').html();

    $(currentfile).find('input').hide().attr('id', '');
    $(currentfile).find('input').get(0).file = file;

    $(currentfile).find('.filename').html('<strong>' + fileName + '</strong>');
    $(currentfile).find('.filesize').html('(' + bytesToSize(fileSize) + ')');
    $(currentfile).find('.fileremove').prop('hidden', false);
    $(currentfile).find('.info-box-icon i').removeClass('fa-upload').addClass(iconclass);

    $(fileswrapper).append(filemodel);
    $('.multiplefiles .singolefile.model').prop('hidden', false).removeClass('model');
    $('.multiplefiles .singolefile:last-child').find('input').attr('id', 'activeFileUpload');

    $("#messageAttachmentWrapper .multiplefiles").sortable("refresh");
}

function rotateInViewer(angle)
{
    var image = $('#faxViewerWrapper').find('.carousel-item.active');
    image.animate({myRotationProperty: angle}, {
        step: function(now, tween) {
            if (tween.prop === "myRotationProperty") {
                $(this).css('-webkit-transform', 'rotate(' + now + 'deg)');
                $(this).css('-moz-transform', 'rotate(' + now + 'deg)');
                $(this).css('transform', 'rotate(' + now + 'deg)');
            }
        }
    });
}

function refreshFormContents() {
    var types = new Array();
    $('input[name=type]').each(function() {
        types.push($(this).val());
    });

    var type = $('input[name=type]:checked').val();

    for (var i = 0; i < types.length; i++) {
        if (types[i] != type)
            $('div[data-display-for*=' + types[i] + ']').hide().find('input').prop('disabled', true).prop('required', false);
    }

    $('div[data-display-for*=' + type + ']').show().find('input').prop('disabled', false).filter(':not(.not-required)').prop('required', true);
}

function checkValidFaxForm() {
    let attachments = $('.faxattachment');
    let missing_old_attachments = $('input:hidden[name="existing_attachment[]"]').length == 0;
    let void_cover = $('input[name=cover_id]:checked').val() == 0;

    if (void_cover && missing_old_attachments && (attachments.length == 0 || attachments.get(0).files.length === 0)) {
        messageModal('È necessario caricare almeno un file allegato oppure una copertina.', 'danger');
        return false;
    }

    var done = true;

    $('.requiredfield').each(function() {
        var group = $(this).closest('div');
        var input = group.find('input');
        if (input.val().trim() == '') {
            input.addClass('is-invalid');
            done = false;
        }
        else {
            input.removeClass('is-invalid');
        }
    });

    if (done == false) {
        messageModal('I campi obbligatori non possono essere vuoti.', 'danger');
        return false;
    }

    return true;
}

$(document).ready(function() {
    j.init({
        initFunction: function(container) {
            commonInit(container);
        },
    });

    $('body').on('shown.bs.modal', '.modal', function(e) {
        $('.sendbutton, .previewbutton').prop("disabled", false);
    });

    $("#searchContact").on("keyup", function() {
        var value = $(this).val().toLowerCase();
        $("#allContacts .contactCard").filter(function() {
            $(this).toggle($(this).attr('data-values').toLowerCase().indexOf(value) > -1);
        });

        if ($("#searchContact").val() != '') {
            $('#allContacts h1').hide();
        }
        else {
            $('#allContacts h1').show();
        }
    });

    if ($('#recipientName').length != 0) {
        $('#recipientName').autocomplete({
            source: $('#recipientName').attr('data-searchurl'),
            minLength: 2,
            select: function(event, ui) {
                $('#recipientName').val(ui.item.label);
                formatNumber(ui.item.number, '#recipientFaxNumberWrapper');
                $('#recipientCompanyName').val(ui.item.company);
            }
        });
    }

    $('body').on('change', '.requires', function(e) {
        var target = $(e.target).attr('data-requires-target');
        $(target).prop('required', e.target.checked);
    });

    $('body').on('click', '.addressbook-picker .contactCard', function() {
        $('input[name=contact_name]').val($(this).find('.contact-name').text());
        formatNumber($(this).find('.contact-number').text(), '#recipientFaxNumberWrapper');
        $('input[name=contact_company]').val($(this).find('.contact-company').text());
        $(this).closest('.modal').modal('hide');
    });

    $('button.emptyallfields').click(function() {
        $(this).parents('.box-body').find('input').val('');
    });

    $('#rechargeAmountForm').on('change', function() {
        var amount = parseFloat($(this).val());
        amount = Number((amount).toFixed(1));
        $('input[name="amount"]').val(amount);
        $('.written-amount').text(amount);
    });

    $('.subscription_selector input[name=subscription]').change(function() {
        if ($(this).prop('checked')) {
            var parent = $(this).closest('.modal');
            $('input[name="subscription_id"]', parent).val($(this).val());
            $('input[name="paypal_plain_id"]', parent).val($(this).attr('data-paypal-plain-id'));
        }
    });

    $(".faxTableRow .multipleFaxAction input").on('change', function(e) {
        checkAnySelected();
    });

    $('button.massiveActionsButton').click(function() {
        var method = $(this).attr('data-method');
        var action = $(this).attr('data-action');
        var destination = $(this).attr('data-destination');
        var reload = $(this).attr('data-reload');

        var values = new Array;
        $('.massiveActionsCheckbox[name="selected[]"]').filter(":checked").each(function() {
            values.push($(this).val());
        });

        var data = {selected: values};

        if (reload == "TRUE") {
            $.ajax({
                url: destination + '/' + action,
                method: 'GET',
                data: data
            }).done(function() {
                location.reload();
            });
        }
        else {
            var url = destination + '/' + action + '?' + $.param(data);

            $('<a />', {
                'href': url,
            }).hide().appendTo("body")[0].click();
        }
    });

    $("#messageAttachmentWrapper .multiplefiles").sortable();

    $('body').on('click', '.singolefile .fileremove', function() {
        $(this).parents('.singolefile').remove();
    });

    $('body').on('change', '.singolefile input[type=file]', function() {
        $(this.files).each(function() {
            multipleFileCell(this);
        });
    });

    $("#cover_enable_button").on('change', function(e) {
        if ($(this).prop('checked')) {
            $('.cover_body').collapse('show');
        }
        else {
            $('.cover_body').collapse('hide');
        }
    });

    $("input.checkallFaxes").on('change', function(e) {
        if (e.target.checked) {
            $(".faxTableRow .multipleFaxAction input").prop('checked', true);
        }
        else {
            $(".faxTableRow .multipleFaxAction input").prop('checked', false);
        }

        checkAnySelected();
    });

    $('body').on('click', '.sendbutton', function(e) {
        e.preventDefault();

        if (checkValidFaxForm() == false) {
            return;
        }
        else {
            var form = $(this).closest('form');
            form.find('input[name=action]').val('send');
            form.removeClass('async-form');
            form.submit();
        }
    });

    $('body').on('click', '.previewbutton', function(e) {
        e.preventDefault();

        if (checkValidFaxForm() == false) {
            return;
        }
        else {
            var form = $(this).closest('form');
            form.find('input[name=action]').val('preview');
            form.addClass('async-form');
            form.submit();
        }
    });

    $('body').on('click', '.alter_on_submit', function(e) {
        let button = $(e.currentTarget);

        e.preventDefault();
        let form = button.closest('form');
        if (form.length == 0) {
            form = $('#' + button.attr('form'));
        }

        let attribute = button.attr('data-alter-attribute');
        let value = button.attr('data-alter-value');
        form.append('<input type="hidden" name="' + attribute + '" value="' + value + '">');
        form.submit();
    });

    $('body').on('click', '#faxViewerWrapper .actions .rotate_left', function() {
        rotateInViewer(90);
    }).on('click', '#faxViewerWrapper .actions .rotate_right', function() {
        rotateInViewer(-90);
    }).on('click', '#faxViewerWrapper .actions .rotate_full', function() {
        rotateInViewer(-180);
    }).on('click', '#faxViewerWrapper .actions .rotate_original', function() {
        rotateInViewer(0);
    });

    if ($('.invoice-config').length != 0) {
        refreshFormContents();

        $('input[name=type]').change(function() {
            if ($(this).prop('checked'))
                refreshFormContents();
        });
    }

    $('body').on('submit', 'form', function() {
        $(this).find('button[type=submit]').prop('disabled', true);
        $(this).find('.sendbuttons').prop('disabled', true);
    });

    $('body').on('submit', '.async-form', function(e) {
        e.preventDefault();

        var form = $(this);
        $('button[type=submit]', form).prop("disabled", true);

        if (form.hasClass('do-modal-response')) {
            $.ajax({
                url: form.attr('action'),
                method: form.attr('method'),
                data: new FormData(this),
                dataType: 'HTML',
                processData: false,
                contentType: false,
                success: function(response) {
                    form.closest('.modal').on('hidden.bs.modal', function() {
                        $(this).remove();
                    }).modal('hide');

                    var d = $(response);
                    commonInit(d);
                    d.modal('show');
                },
                error: function() {
                    messageModal('Si è verificato un errore inatteso. Si prega di riprovare.', 'danger');
                },
                done: function() {
                    $('button[type=submit]', form).prop("disabled", false);
                }
            });
        } else {
            $.ajax({
                url: form.attr('action'),
                method: form.attr('method'),
                data: form.serializeArray(),
                success: function(response) {
                    form.closest('.modal').on('hidden.bs.modal', function() {
                        $(this).remove();
                    }).modal('hide');
                },
                error: function() {
                    messageModal('Si è verificato un errore inatteso. Si prega di riprovare', 'danger');
                },
                done: function() {
                    $('button[type=submit]', form).prop("disabled", false);
                }
            });
        }
    });

    startPaypal();
});
